import React from 'react';
import { ui, msgColor } from '../../styles/shared';

// Stilar från den gemensamma stilfilen
const card = ui.card;
const btn = ui.btn;
const inputStyle = ui.input;
const labelStyle = ui.label;
const hintStyle = ui.hint;

interface Props {
    settingsForm: Record<string, string>;
    settingsSaving: boolean;
    settingsMsg: string | null;
    onSettingsChange: (fn: (prev: Record<string, string>) => Record<string, string>) => void;
    onSaveSettings: (payload: Record<string, any>) => void;
}

/**
 * Per-device offline-detection override. Rendered for ALL coordinator-managed Zigbee
 * devices (not just the four sensor types) — the backend honours offline_timeout_hours /
 * offline_detection for every device type, so the UI must expose it universally.
 */
const OfflineDetectionPanel: React.FC<Props> = ({
    settingsForm, settingsSaving, settingsMsg, onSettingsChange, onSaveSettings,
}) => (
    <div style={card}>
        <h4 style={{ marginTop: 0 }}>Bevakning av frånkopplade enheter</h4>
        <div style={{ maxWidth: '380px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
            <div>
                <label style={labelStyle}>Räknas som frånkopplad efter (timmar)</label>
                <input type="number" min="0" step="0.5" placeholder="standard"
                    value={settingsForm.offline_timeout_hours ?? ''}
                    onChange={e => onSettingsChange(p => ({ ...p, offline_timeout_hours: e.target.value }))}
                    style={inputStyle} />
                <span style={hintStyle}>Lämna tomt för standard: EndDevice 5 h, Router 90 min.</span>
            </div>
            <div>
                <label style={labelStyle}>Så här upptäcks frånkopplade enheter</label>
                <select
                    value={settingsForm.offline_detection ?? 'normal'}
                    onChange={e => onSettingsChange(p => ({ ...p, offline_detection: e.target.value }))}
                    style={{ ...inputStyle, cursor: 'pointer' }}>
                    <option value="normal">Vanlig (efter en viss tid utan livstecken)</option>
                    <option value="event_driven">Bara vid händelser (ingen tidsgräns, t.ex. dörrgivare)</option>
                </select>
                <span style={hintStyle}>Med ”bara vid händelser” larmas det aldrig för tystnad.</span>
            </div>
        </div>
        <button disabled={settingsSaving}
            onClick={() => {
                const payload: Record<string, any> = {};
                if (settingsForm.offline_timeout_hours !== undefined && settingsForm.offline_timeout_hours !== '') {
                    payload.offline_timeout_hours = Number(settingsForm.offline_timeout_hours);
                } else {
                    payload.offline_timeout_hours = null;
                }
                if (settingsForm.offline_detection) {
                    payload.offline_detection = settingsForm.offline_detection === 'event_driven' ? 'event_driven' : null;
                }
                onSaveSettings(payload);
            }}
            style={{ ...btn(settingsSaving ? '#6c757d' : '#28a745'), marginTop: '12px', cursor: settingsSaving ? 'not-allowed' : 'pointer' }}>
            {settingsSaving ? 'Sparar…' : 'Spara inställningarna'}
        </button>
        {settingsMsg && <p style={{ margin: '10px 0 0 0', fontSize: '14px', color: msgColor(settingsMsg) }}>{settingsMsg}</p>}
    </div>
);

export default OfflineDetectionPanel;
